import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
// import "./styles/styles.css";

const container: HTMLElement | null = document.getElementById('root');
if (container !== null) {
    const root = createRoot(container);

    root.render(
        <React.StrictMode>
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </React.StrictMode>
    );
}
